import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router";
import Ecommerce from "./pages/Dashboard/Ecommerce";
import Stocks from "./pages/Dashboard/Stocks";
import Crm from "./pages/Dashboard/Crm";
import Marketing from "./pages/Dashboard/Marketing";
import Analytics from "./pages/Dashboard/Analytics";
import AuthLayout from "./layout/AuthLayout";
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import NotFound from "./pages/OtherPage/NotFound";
import UserProfiles from "./pages/UserProfiles";
import Carousel from "./pages/UiElements/Carousel";
import Maintenance from "./pages/OtherPage/Maintenance";
import FiveZeroZero from "./pages/OtherPage/FiveZeroZero";
import FiveZeroThree from "./pages/OtherPage/FiveZeroThree";
import Videos from "./pages/UiElements/Videos";
import Images from "./pages/UiElements/Images";
import Alerts from "./pages/UiElements/Alerts";
import Badges from "./pages/UiElements/Badges";
import Pagination from "./pages/UiElements/Pagination";
import Avatars from "./pages/UiElements/Avatars";
import Buttons from "./pages/UiElements/Buttons";
import ButtonsGroup from "./pages/UiElements/ButtonsGroup";
import Notifications from "./pages/UiElements/Notifications";
import LineChart from "./pages/Charts/LineChart";
import BarChart from "./pages/Charts/BarChart";
import PieChart from "./pages/Charts/PieChart";
import Invoices from "./pages/Invoices";
import ComingSoon from "./pages/OtherPage/ComingSoon";
import FileManager from "./pages/FileManager";
import Calendar from "./pages/Calendar";
import BasicTables from "./pages/Tables/BasicTables";
import DataTables from "./pages/Tables/DataTables";
import PricingTables from "./pages/PricingTables";
import Faqs from "./pages/Faqs";
import Chats from "./pages/Chat/Chats";
import FormElements from "./pages/Forms/FormElements";
import FormLayout from "./pages/Forms/FormLayout";
import Blank from "./pages/Blank";
import EmailInbox from "./pages/Email/EmailInbox";
import EmailDetails from "./pages/Email/EmailDetails";
import TaskList from "./pages/Task/TaskList";
import TaskKanban from "./pages/Task/TaskKanban";
import BreadCrumb from "./pages/UiElements/BreadCrumb";
import Cards from "./pages/UiElements/Cards";
import Dropdowns from "./pages/UiElements/Dropdowns";
import Links from "./pages/UiElements/Links";
import Lists from "./pages/UiElements/Lists";
import Popovers from "./pages/UiElements/Popovers";
import Progressbar from "./pages/UiElements/Progressbar";
import Ribbons from "./pages/UiElements/Ribbons";
import Spinners from "./pages/UiElements/Spinners";
import Tabs from "./pages/UiElements/Tabs";
import Tooltips from "./pages/UiElements/Tooltips";
import EmailLayout from "./components/email/EmailLayout";
import Modals from "./pages/UiElements/Modals";
import ResetPassword from "./pages/AuthPages/ResetPassword";
import TwoStepVerification from "./pages/AuthPages/TwoStepVerification";
import Success from "./pages/OtherPage/Success";
import AppLayout from "./layout/AppLayout";
import Products from "./pages/MasterTable/Products/Products";
import AddNewProduct from "./pages/MasterTable/Products/AddNewProduct";
import TabList from "./pages/MasterTable/Products/Tabs/TabList";
import CustomerSurveys from "./pages/Daily Dairy/CustomerSurvey/CustomerSurveys";
import AddNewSurvey from "./pages/Daily Dairy/CustomerSurvey/AddNewSurvey";
import Home from "./pages/Home/Home";
import CreatingUserAccount from "./pages/TrainingVideos/CreatingUserAccount";
import IntroductionHospitalityGenie from "./pages/TrainingVideos/GenieIntroduction";
import BudgetFunction from "./pages/TrainingVideos/BudgetFunction";
import ComplianceFunction from "./pages/TrainingVideos/ComplianceFunction";
import DeliveryPartOne from "./pages/TrainingVideos/DeliveryPartOne";
import DeliveryPartTwo from "./pages/TrainingVideos/DeliveryPartTwo";
import OrderFromSupplier from "./pages/TrainingVideos/OrderFromSupplier"; 
import IntroductionSupplierPartOne from "./pages/TrainingVideos/IntroductionSupplierPartOne";
import IntroductionSupplierPartTwo from "./pages/TrainingVideos/IntroductionSupplierPartTwo"; 
import Workflows from "./pages/TrainingVideos/Workflows";
import CreatingInventoriesAndStocktakes from "./pages/TrainingVideos/CreatingInventoriesAndStocktakes";
import IntroProductAndSuppliers from "./pages/TrainingVideos/IntroductionProductAndSupplier";
import Heading from "./pages/ComplianceInspections/Heading/Heading";
import AddNewHeading from "./pages/ComplianceInspections/Heading/AddNewHeading";
import Updateheading from "./pages/ComplianceInspections/Heading/Updateheading";
import InspectionItems from "./pages/ComplianceInspections/InspectionItems/InspectionItems";
import AddNewInspectionItem from "./pages/ComplianceInspections/InspectionItems/AddNewInspectionItem";
import UpdateInspectionItems from "./pages/ComplianceInspections/InspectionItems/UpdateInspectionItems";
import InspectionTypes from "./pages/ComplianceInspections/InspectionTypes/InspectionTypes";
import AddNewInspectionTypesTabList from "./pages/ComplianceInspections/InspectionTypes/AddInspectionTypeTabList";
import UpdateInspectionTypes from "./pages/ComplianceInspections/InspectionTypes/TabList";
import ComplianceInspectionsHistory from "./pages/ComplianceInspections/InspectionsHistory/InspectionsHistory";
import AddNewInspectionHistory from "./pages/ComplianceInspections/InspectionsHistory/AddInspectionHistory";
import InspectionHistoryUpdate from "./pages/ComplianceInspections/InspectionsHistory/TabList";
import VenueAreas from "./pages/ComplianceInspections/VenueAreas/VenueAreas";
import AddNewVenueArea from "./pages/ComplianceInspections/VenueAreas/AddNewVenueArea";
import UpdateVenueArea from "./pages/ComplianceInspections/VenueAreas/UpdateVenueArea";
import RemedialActions from "./pages/ComplianceInspections/RemedialActions/RemedialActions";
import UpdateRemedialActions from "./pages/ComplianceInspections/RemedialActions/TabList";
import WorkFlows from "./pages/WorkFlows/WorkFlows/Workflows";
import Tasks from "./pages/WorkFlows/Tasks/Tasks";
import Areas from "./pages/WorkFlows/LookUpTables/Areas/Areas";
import AddNewArea from "./pages/WorkFlows/LookUpTables/Areas/AddNewAreas";
import UpdateArea from "./pages/WorkFlows/LookUpTables/Areas/UpdateAreas";
import WorkflowCategory from "./pages/WorkFlows/LookUpTables/WorkflowCategories/WorkflowCategories";
import AddNewWorkflowCategory from "./pages/WorkFlows/LookUpTables/WorkflowCategories/AddNewWorkflowCategories";
import UpdateWorkflowCategory from "./pages/WorkFlows/LookUpTables/WorkflowCategories/UpdateWorkflowCategories";
import ReasonsTaskNotCompleted from "./pages/WorkFlows/LookUpTables/ReasonsTaskNotCompleted/ReasonsTaskNotCompleted";
import AddNewReasonsTaskNotCompleted from "./pages/WorkFlows/LookUpTables/ReasonsTaskNotCompleted/AddNewReasonsTaskNotCompleted";
import UpdateReasonsTaskNotCompleted from "./pages/WorkFlows/LookUpTables/ReasonsTaskNotCompleted/UpdateReasonsTaskNotCompleted";
import TemperatureCheckItems from "./pages/WorkFlows/LookUpTables/TemperatureCheckItems/TemperatureCheckItems";
import AddTemperatureCheckItems from "./pages/WorkFlows/LookUpTables/TemperatureCheckItems/AddTemperatureCheckItems";
import UpdateTemperatureCheckItems from "./pages/WorkFlows/LookUpTables/TemperatureCheckItems/UpdateTemperatureCheckItems";
import SpecialOccasionMenus from "./pages/SpecialOccasionMenus/SpecialOccasionMenus";
import AddSpecialOccasionMenu from "./pages/SpecialOccasionMenus/AddSpecialOccasionMenu";
import UpdateSpecialOccasionMenu from "./pages/SpecialOccasionMenus/UpdateSpecialOccasionMenu";
import VenueOutlets from "./pages/VenueOutlets/VenueOutlets";
import AddVenueOutlet from "./pages/VenueOutlets/AddVenueOutlet";
import UpdateVenueOutlet from "./pages/VenueOutlets/UpdateVenueOutlet";
import Dietaries from "./pages/Dietaries/Dietaries";
import AddDietary from "./pages/Dietaries/AddDietary";
import UpdateDietary from "./pages/Dietaries/UpdateDietary";

const apiUrl = process.env.REACT_APP_API_URL;

export default function App() {
  const [isInitialized, setIsInitialized] = useState(false);

  // Synchronous initialization - runs before first render
  if (!isInitialized) {
    const params = new URLSearchParams(window.location.search);
    const sessionid = params.get("token");
    
    // console.log("Setting token synchronously...");
    
    if (sessionid) {
      // Use immediate function to handle async operation
      (async () => {
        try {
          const loginRes = await fetch(
            `${apiUrl}/auth?sessionid=${encodeURIComponent(sessionid)}`,
            {
              method: "GET",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
            }
          );

          const loginData = await loginRes.json();

          if (loginRes.ok && loginData.token) {
            localStorage.setItem("token", loginData.token);
          }
        } catch (error) {
          console.error("Error setting token:", error);
        } finally {
          setIsInitialized(true);
        }
      })();
      
      // Return loading while async operation completes
      return <div>Please Wait to be redirected...</div>;
    } else {
      // No token to set, mark as initialized immediately
      setIsInitialized(true);
    }
    
    // This will prevent rendering until setIsInitialized is called
    // return <div>Initializing...</div>;
  }
  

  return (
    <>
      <Router>
        <Routes>
          {/* Dashboard Layout */}
          <Route element={<AppLayout />}>
            <Route index path="/" element={<Home />} />
            <Route path="/ecommerce" element={<Ecommerce />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/crm" element={<Crm />} />
            <Route path="/stocks" element={<Stocks />} />

            {/* Master Table */}
            <Route path="/products" element={<Products />} />
            <Route path="/add-new-product" element={<AddNewProduct />} />
            <Route path="/update-product" element={<TabList />} />

            {/* Daily Diary */}
            <Route path="/customer-surveys" element={<CustomerSurveys />} />
            <Route path="add-new-survey" element={<AddNewSurvey />} />

            {/* Menus */}
            <Route path="/special-occasion-menus" element={<SpecialOccasionMenus />} />
            <Route path="/add-special-occasion-menu" element={<AddSpecialOccasionMenu />} />
            <Route path="/update-special-occasion-menu" element={<UpdateSpecialOccasionMenu />} />
            <Route path="/update-special-occasion-menu/:id" element={<UpdateSpecialOccasionMenu />} />
            <Route path="/venue-outlets" element={<VenueOutlets />} />
            <Route path="/add-venue-outlet" element={<AddVenueOutlet />} />
            <Route path="/update-venue-outlet" element={<UpdateVenueOutlet />} />
            <Route path="/dietaries" element={<Dietaries />} />
            <Route path="/add-dietary" element={<AddDietary />} />
            <Route path="/update-dietary" element={<UpdateDietary />} />

            {/* Compliance Inspections */}
            <Route path="/headings" element={<Heading />} />
            <Route path="/add-new-heading" element={<AddNewHeading />} />
            <Route path="/update-heading" element={<Updateheading />} />
            {/*Inspections Items */}
            <Route path="/inspection-items" element={<InspectionItems />} />
            <Route path="/add-new-inspection-item" element={<AddNewInspectionItem />} />
            <Route path="/update-inspection-item" element={<UpdateInspectionItems />} />
            {/*Inspections Types */}
            <Route path="/inspection-types" element={<InspectionTypes />} />
            <Route path="/add-new-inspection-type" element={<AddNewInspectionTypesTabList />} />
            <Route path="/update-inspection-type" element={<UpdateInspectionTypes />} />
            {/*Inspections History */}
            <Route path="/inspections-history" element={<ComplianceInspectionsHistory />} />
            <Route path="/add-new-inspection-history" element={<AddNewInspectionHistory />} />
            <Route path="/update-inspection-history" element={<InspectionHistoryUpdate />} />
            {/*Venue Areas */}
            <Route path="/venue-areas" element={<VenueAreas />} />
            <Route path="/add-new-venue-area" element={<AddNewVenueArea />} />
            <Route path="/update-venue-area" element={<UpdateVenueArea />} />
            {/*Remedial Actions */}
            <Route path="/remedial-actions" element={<RemedialActions />} />
            <Route path="/update-remedial-actions" element={<UpdateRemedialActions />} />
            {/* WorkFlows */}
            <Route path="/workflows" element={<WorkFlows />} />
            {/* Tasks */}
            <Route path="/tasks" element={<Tasks />} />
            {/* Areas */}
            <Route path="/areas" element={<Areas />} />
            <Route path="/add-new-area" element={<AddNewArea />} />
            <Route path="/update-area" element={<UpdateArea />} />
            {/* Workflow Categories */}
            <Route path="/workflow-categories" element={<WorkflowCategory />} />
            <Route path="/add-new-workflow-category" element={<AddNewWorkflowCategory />} />
            <Route path="/update-workflow-category" element={<UpdateWorkflowCategory />} />
            {/* Reasons Task Not Completed */}
            <Route path="/reasons-task-not-completed" element={<ReasonsTaskNotCompleted />} />
            <Route path="/add-new-reason-task-not-completed" element={<AddNewReasonsTaskNotCompleted />} />
            <Route path="/update-reason-task-not-completed" element={<UpdateReasonsTaskNotCompleted />} />
            {/* Temperature Check Items */}
            <Route path="/temperature-check-items" element={<TemperatureCheckItems />} />
            <Route path="/add-new-temperature-check-item" element={<AddTemperatureCheckItems />} />
            <Route path="/update-temperature-check-item" element={<UpdateTemperatureCheckItems />} />

            {/* Training videos */}
            <Route path="/hospitality-genie-introduction" element={<IntroductionHospitalityGenie />} />
            <Route path="/user-accounts" element={<CreatingUserAccount />} />
            <Route path="/budget-function" element={<BudgetFunction />} />
            <Route path="/compliance-function" element={<ComplianceFunction />} />
            <Route path="/supplier-ordering" element={<OrderFromSupplier />} />
            <Route path="/delivery-processing-1" element={<DeliveryPartOne />} />
            <Route path="/delivery-processing-2" element={<DeliveryPartTwo />} />
            <Route path="/introduction-supplier-1" element={<IntroductionSupplierPartOne />} />
            <Route path="/introduction-supplier-2" element={<IntroductionSupplierPartTwo />} />
            <Route path="/workflows-function" element={<Workflows />} />
            <Route path="/creating-inventories-and-stocktakes" element={<CreatingInventoriesAndStocktakes />} />
            <Route path="/intro-products-and-suppliers" element={<IntroProductAndSuppliers />} />
            

            {/* Others Page */}
            <Route path="/profile" element={<UserProfiles />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/invoice" element={<Invoices />} />
            <Route path="/faq" element={<Faqs />} />
            <Route path="/pricing-tables" element={<PricingTables />} />
            <Route path="/blank" element={<Blank />} />

            {/* Forms */}
            <Route path="/form-elements" element={<FormElements />} />
            <Route path="/form-layout" element={<FormLayout />} />

            {/* Applications */}
            <Route path="/chat" element={<Chats />} />

            <Route path="/task-list" element={<TaskList />} />
            <Route path="/task-kanban" element={<TaskKanban />} />
            <Route path="/file-manager" element={<FileManager />} />

            {/* Email */}
            <Route element={<EmailLayout />}>
              <Route path="/inbox" element={<EmailInbox />} />
              <Route path="/inbox-details" element={<EmailDetails />} />
            </Route>

            {/* Tables */}
            <Route path="/basic-tables" element={<BasicTables />} />
            <Route path="/data-tables" element={<DataTables />} />

            {/* Ui Elements */}
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/avatars" element={<Avatars />} />
            <Route path="/badge" element={<Badges />} />
            <Route path="/breadcrumb" element={<BreadCrumb />} />
            <Route path="/buttons" element={<Buttons />} />
            <Route path="/buttons-group" element={<ButtonsGroup />} />
            <Route path="/cards" element={<Cards />} />
            <Route path="/carousel" element={<Carousel />} />
            <Route path="/dropdowns" element={<Dropdowns />} />
            <Route path="/images" element={<Images />} />
            <Route path="/links" element={<Links />} />
            <Route path="/list" element={<Lists />} />
            <Route path="/modals" element={<Modals />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/pagination" element={<Pagination />} />
            <Route path="/popovers" element={<Popovers />} />
            <Route path="/progress-bar" element={<Progressbar />} />
            <Route path="/ribbons" element={<Ribbons />} />
            <Route path="/spinners" element={<Spinners />} />
            <Route path="/tabs" element={<Tabs />} />
            <Route path="/tooltips" element={<Tooltips />} />
            <Route path="/videos" element={<Videos />} />

            {/* Charts */}
            <Route path="/line-chart" element={<LineChart />} />
            <Route path="/bar-chart" element={<BarChart />} />
            <Route path="/pie-chart" element={<PieChart />} />
          </Route>

          {/* Auth Layout */}
          <Route element={<AuthLayout />}>
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/two-step-verification"
              element={<TwoStepVerification />}
            />
          </Route>

          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/success" element={<Success />} />
          <Route path="/five-zero-zero" element={<FiveZeroZero />} />
          <Route path="/five-zero-three" element={<FiveZeroThree />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
        </Routes>
      </Router>
    </>
  );
}
